module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "c-box"
  }, [_c('header', {
    staticClass: "c-box__heading",
    on: {
      "click": _vm.toggleVariationInfo
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight",
    class: _vm.toggleIconClass()
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [_c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('gender.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('gender', _vm.variation.sku)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.gender),
      expression: "variation.gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.variation, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "null"
    }
  }, [_vm._v("\n                  Selecione\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.male.label')) + "\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.female.label')) + "\n                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "unisex"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('gender.unisex.label')) + "\n                ")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('crossDocking.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('crossDocking', _vm.variation.sku)
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.crossDocking),
      expression: "variation.crossDocking"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "crossDocking", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("dias")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('manufacturerReference.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('manufacturerReference', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.manufacturerReference),
      expression: "variation.manufacturerReference"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.manufacturerReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "manufacturerReference", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "EAN",
      "columns": 4,
      "error": _vm.getErrorBySku('ean', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.ean),
      expression: "variation.ean"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.ean)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "ean", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('quantity.label'),
      "columns": 4,
      "error": _vm.getErrorBySku('quantity', _vm.variation.sku)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.quantity),
      expression: "variation.quantity"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.variation.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "quantity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._l((Object.keys(_vm.variation.attributes)), function(label) {
    return _c('form-group', {
      attrs: {
        "label": _vm.$t((label + ".label")),
        "columns": 4,
        "error": _vm.getErrorBySku(label, _vm.variation.sku)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.variation.attributes[label]),
        expression: "variation.attributes[label]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.variation.attributes[label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.variation.attributes, label, $event.target.value)
        }
      }
    })])
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Peso",
      "columns": 4,
      "error": _vm.getErrorBySku('weight', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.weight),
      expression: "variation.weight"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "weight", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("g")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Altura",
      "columns": 4,
      "error": _vm.getErrorBySku('height', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.height),
      expression: "variation.height"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "height", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Largura",
      "columns": 4,
      "error": _vm.getErrorBySku('width', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.width),
      expression: "variation.width"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "width", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Comprimento",
      "columns": 4,
      "error": _vm.getErrorBySku('length', _vm.variation.sku),
      "required": true
    }
  }, [_c('div', {
    staticClass: "form-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.length),
      expression: "variation.length"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.variation.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation, "length", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-addon"
  }, [_vm._v("cm")])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Preço antigo",
      "columns": 4,
      "error": _vm.getErrorBySku('previousPrice', _vm.variation.sku),
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    model: {
      value: (_vm.variation.previousPrice),
      callback: function($$v) {
        _vm.$set(_vm.variation, "previousPrice", $$v)
      },
      expression: "variation.previousPrice"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Preço atual",
      "columns": 4,
      "error": _vm.getErrorBySku('currentPrice', _vm.variation.sku),
      "required": true
    }
  }, [_c('money', _vm._b({
    staticClass: "form-input",
    model: {
      value: (_vm.variation.currentPrice),
      callback: function($$v) {
        _vm.$set(_vm.variation, "currentPrice", $$v)
      },
      expression: "variation.currentPrice"
    }
  }, 'money', _vm.money, false))], 1)], 1), _vm._v(" "), _c('product-provide-image', {
    attrs: {
      "variation": _vm.variation
    }
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.variationTitle()))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0758c8a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/Edit/Api/Variation.vue
// module id = 2883
// module chunks = 0